import PropTypes from 'prop-types';
import React from 'react';

import ConversationItem from 'models/conversation_item';
import ConversationItemType from 'models/conversation_item_type';
import Metadata from './metadata';
import { typeReflect } from 'models/conversation_item/content_from_js';

export default function SystemMetadata({ iconClass, item, text, subject }) {
  const itemType = typeReflect.instanceToType(item.content);
  if (itemType !== ConversationItemType.PROACTIVE_CHAT_CONTENT) {
    return null;
  }
  return <Metadata iconClass={iconClass} isInbound={false} timestamp={item.timestamp} subject={subject} text={text} />;
}

SystemMetadata.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  text: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/metadata/system_metadata.jsx